import React from 'react';
import HlsPlayer from 'react-hls-player';

import { useVideoPlayer } from './use-video-player';
import { VideoPlayerMethods, VideoPlayerProps } from './video-player.type';

export const VideoPlayer = React.forwardRef<
  VideoPlayerMethods,
  VideoPlayerProps
>((props, ref) => {
  const {
    source,
    width,
    height,
    resizeMode = 'cover',
    controls = false,
    onError,
    onEnded,
    onLoad,
  } = props;

  const { videoRef } = useVideoPlayer<HTMLVideoElement>(ref);

  const isMp4 = source.uri.includes('.mp4');
  const style: React.CSSProperties = { objectFit: resizeMode };

  if (isMp4) {
    return (
      <video
        ref={videoRef}
        controls={controls}
        width={width}
        height={height}
        onError={onError}
        onEnded={onEnded}
        onLoadedData={onLoad}
        style={style}
      >
        <source src={source.uri} type="video/mp4" />
      </video>
    );
  }

  return (
    <HlsPlayer
      autoPlay
      playerRef={videoRef}
      src={source.uri}
      controls={controls}
      width={width}
      height={height}
      onError={onError}
      onEnded={onEnded}
      onLoadedData={onLoad}
      style={style}
    />
  );
});
